/**
 * A super module that collects available sub-modules.
 *
 * @namespace vef.ui.sidebar
 * @memberof vef.ui
 */

export * from "./Sidebar.js";
export * from "./SidebarElement.js";
